module.exports = __webpack_public_path__ + "img/mac-icon.76e14329.png";